export enum LectureAccess {
    PRIVATE = 0,
    PUBLIC = 1
}

export interface Lecture {
    id: number;
    title: string;
    duration: number;
    start_time: string;
    access: LectureAccess;
    record: boolean;
    collection_id: number | null;
    expected_students: number;
    notified_students: boolean;
    last_updated: string;
    classroom_id: number;
}

export const newLecture = (): Lecture => ({
    id: 0,
    title: '',
    duration: 0,
    start_time: '',
    access: LectureAccess.PRIVATE,
    record: false,
    collection_id: null,
    expected_students: 0,
    notified_students: false,
    last_updated: '',
    classroom_id: 0,
});

export function newLecturePayload(classroom_id: number, lecture: Lecture) {
    return {
        title: lecture.title,
        access: lecture.access,
        expected_students: lecture.expected_students,
        classroom_id: lecture.classroom_id
    }
}

export function updateLecturePayload(lecture: Lecture) {
    return {
        id: lecture.id,
        title: lecture.title,
        access: lecture.access,
        duration: lecture.duration,
        start_time: lecture.start_time,
        record: lecture.record,
        collection_id: lecture.collection_id
    }
}
